import React from 'react';

const PageTitleServicesInside = ({title}) => {
  return (
    <div id="page-title">
      <div className="wrapper text-center">
        <h1 className="large">{title}</h1>
      </div>
    </div>
  );
};

export default PageTitleServicesInside;
